import * as Sentry from '@sentry/react';

// Initialize Sentry for the browser SPA. No-op when VITE_SENTRY_DSN is unset
// (e.g. local dev), so contributors don't need a DSN to run the app.
//
// `release` is injected automatically at build time by @sentry/vite-plugin
// (see vite.config.ts) — do not set it here.
export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    // Performance tracing sample rate — modest default for pilot scale; bump
    // via VITE_SENTRY_TRACES_SAMPLE_RATE if you need more transaction volume.
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? '0.1'),
  });
}
